const type = 'CLEAR_ATTENDANCE_NOTE';

const clearAttendanceNote = (data) => ({
  data,
  type,
});

export default clearAttendanceNote;
